import React, { useEffect, useRef, useState } from 'react'
import Draggable from 'react-draggable'
import { axiosInstance } from '../../../Helpers/axiosInstance';
import CustomSelect from '../../../Components/CustomSelect';

export default function PeopleInformation({unitId, onClose, fillArrayHandler}) {
  const [people, setPeople] = useState([]);
  const [person,setPerson] = useState("");
  const [personObject, setPersonObject] = useState(null);


  const [rang, setRang] = useState("")
  const [position, setPosition] = useState("")
  const [fullName, setFullName] = useState("")
  const [birthday, setBirthday] = useState("")
  const [conscription, setConscription] = useState("")
  const [milCommissariat, setMilCommissariat] = useState("")
  const [address, setAddress] = useState("")
  const [type, setType] = useState("haveTo")
  const [battalion, setBattalion] = useState("")
  const [company, setCompany] = useState("")
  const [platoon, setPlatoon] = useState("")
  const [weapons, setWeapons] = useState([])
  const [weapon, setWeapon] = useState("")
  const [weaponNumber, setWeaponNumber] = useState("")
  const [other, setOther] = useState("")
  
  const nodeRef = useRef(null);
  let obj

  const fetchData = async () => {
      const response = await axiosInstance(`/admin/people/${unitId}`)
      if(response.data.status){
          setPeople(response.data.data)
      };
  }

  useEffect(() => {
    if(personObject){
        obj = {
              rang: `${rang} ${type === "haveTo" ? "" : "(Պ)"}` ,
              special_radio: personObject.special,           
              full_name: fullName,
              conscription,
              subvision: `${personObject.battalion.battalion_number} ${personObject.battalion.battalion_name} ${personObject.company.company_number} ${personObject.platoon.platoon_number}`,
              position,
              gun_type: weapon,
              gun_number: weaponNumber,
              other_information: other,
        }
    }
  }, [person,personObject, weapon, weaponNumber, other])

  useEffect(() => {
      fetchData();
  }, []);

  useEffect(() => {
      if(person){
          setPersonObject(people.find(el => el._id === person))
      }
  }, [person])

  useEffect(() => {
      if(personObject){
          setRang(personObject.rang)
          setPosition(personObject.position)
          setFullName(personObject.full_name)
          setBirthday(personObject.birthday.slice(0, 10))
          setConscription(personObject.conscription)
          setMilCommissariat(personObject.mil_commissariat)
          setAddress(personObject.address)
          setType(personObject.type)
          setBattalion(personObject.battalion.battalion_number + " " + personObject.battalion.battalion_name)
          setCompany(personObject.company.company_number)
          setPlatoon(personObject.platoon.platoon_number)
          setWeapon(personObject.weapon)
          setWeaponNumber(personObject.weapon_number)
      }else{
          setRang("")
          setPosition("")
          setFullName("")
          setBirthday("")
          setConscription("")
          setMilCommissariat("")
          setAddress("")
          setType("haveTo")
          setBattalion("")
          setCompany("")
          setPlatoon("")
          setWeapon("")
          setWeaponNumber("")
      }
  }, [personObject])

  useEffect(() => {
          (async() => {
              const weapons = await axiosInstance.get('admin/weapons')
              if(weapons.status){
                  setWeapons(weapons.data.data)
              }
          })()
  }, [])

  return (
    <div className='fixed w-screen h-screen bg-black/40 top-0 left-0 flex justify-center items-center' onClick={onClose}>
         <Draggable nodeRef={nodeRef} bounds='parent' cancel=".no-drag">
            <div ref={nodeRef} className='max-w-[90%] max-h-[90%] bg-white rounded-lg p-4' onClick={e => e.stopPropagation()}>
              <h2 className='text-center mb-4'>Անձնակազմի Մուտքագրում</h2>
              <div className='grid grid-cols-2 gap-4'>
                  <div className='no-drag'>
                      <CustomSelect 
                          defaultValueForInput={person ? person.full_name : ""}
                          options={people?.map((el,i) => <option key={i} value={el._id}>{el.rang + " " + el.full_name + ", " + el.mil_commissariat + " Զինկոմիսարիատ"}</option>)}
                          callback={setPerson}
                          label="Ընտրել զինծառայողին"
                      />
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-gradient-to-t from-gray-200 to-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="rang">Զինկոչում</label>
                      <input type="text" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' disabled value={rang + " " + (type&& type === "haveTo" ? "" : "Պ")} />
                  </div>
                  <div className='no-drag'>
                      <div onMouseDown={(e) => e.stopPropagation()}>
                          <CustomSelect 
                              defaultValueForInput={weapon}
                              options={weapons?.map((el,i) => <option key={el._id} value={el.weapon_name}>{el.weapon_name}</option>)}
                              callback={setWeapon}
                              label="Զենքի տեսակը"
                              many={true}
                          />
                      </div>
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap" htmlFor="weaponNumber">Զենքի համարը</label>
                      <input type="text" id="weaponNumber" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={weaponNumber} onChange={(e) => setWeaponNumber(e.target.value)} />
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap " htmlFor="other">Այլ նշումներ</label>
                      <input type="text" id="other" className='border border-gray-500 rounded-md p-2 w-full' value={other} onChange={(e) => setOther(e.target.value)} />
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="birthday">Ծննդյան տարեթիվ</label>
                      <input type="date" id="birthday" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' disabled value={birthday}/>
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] bg-gradient-to-t from-gray-200 to-white" htmlFor="position">Պաշտոն</label>
                      <input className='border border-gray-500 rounded-md p-2 disabled:bg-gray-200' id="position" type="text" value={position} disabled />
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] bg-gradient-to-t from-gray-200 to-white" htmlFor="battalion">Գումարտակ</label>
                      <input className='border border-gray-500 rounded-md p-2 disabled:bg-gray-200' id="battalion" type="text" value={battalion} disabled />
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] bg-gradient-to-t from-gray-200 to-white" htmlFor="company">Վաշտ</label>
                      <input className='border border-gray-500 rounded-md p-2 disabled:bg-gray-200' id="company" type="text" value={company} disabled />
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] bg-gradient-to-t from-gray-200 to-white" htmlFor="platoon">Դասակ</label>
                      <input className='border border-gray-500 rounded-md p-2 disabled:bg-gray-200' id="platoon" type="text" value={platoon} disabled />
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="conscription">Զորակոչ</label>
                      <input type="text" id="conscription" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={conscription} disabled/>
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="milCommissariat">Զինկոմիսարիատ</label>
                      <input type="text" id="milCommissariat" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={milCommissariat} disabled />
                  </div>
                  <div className='relative no-drag'>
                      <label className="absolute top-[-0.5rem] bg-white ml-2 text-sm px-[4px] text-nowrap bg-gradient-to-t from-gray-200 to-white" htmlFor="address">Հասցե</label>
                      <input type="text" id="address" className='border border-gray-500 rounded-md p-2 w-full disabled:bg-gray-200' value={address} disabled />
                  </div>

              </div>
              <div className='grid grid-cols-2 gap-4 justify-center items-center '>
                <button className='mt-4 bg-blue-500 text-white px-4 py-2 rounded-md' onClick={() => fillArrayHandler(obj)}>Պահպանել</button>
                <button className='mt-4 bg-gray-300 text-white px-4 py-2 rounded-md ' onClick={onClose}>Փակել</button>
              </div>
            </div>
         </Draggable>
    </div>
  )
}
